const path = 'equipement-maintenances/'

const list = ({ opt = {} }) => axios.get(path, opt)
const create = ({ form, opt = {} }) => axios.post(path, form, opt)
const edit = ({ pk, form, opt = {} }) => axios.put(`${path}${pk}/`, form, opt)
const show = ({ pk, opt = {} }) => axios.get(`${path}${pk}/`, opt)
const remove = ({ pk }) => axios.delete(`${path}${pk}/`)

const pathPayment = 'maintenance-payments/'
const payment = {
  list: ({ opt = {} }) => axios.get(pathPayment, opt),
  create: ({ form, opt = {} }) => axios.post(pathPayment, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${pathPayment}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${pathPayment}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${pathPayment}${pk}/`)
}

export default { list, create, edit, show, remove, payment }
